import { FC, memo } from 'react'
import cn from 'classnames'
import { PlaceholderCell } from 'components/extend/PlaceholderCell'
import { formatDateToMoscow } from 'helpers/dates'

import { useFindTrackingQuery } from '../../api'
import { getFilteredAndRenamedOrderTracking } from './helpers'

interface OrderYarcheTrackingProps {
  barcode: string
  className?: string
}

const OrderYarcheTracking: FC<OrderYarcheTrackingProps> = (props) => {
  const { className, barcode } = props

  const { data, isLoading, isError } = useFindTrackingQuery(barcode)
  const tracking = data?.tracking || []

  if (isLoading) {
    return (
      <div className={className}>
        <div className="mb-4 text-title-lg">История перевозки</div>
        <div className="flex flex-col gap-y-1">
          <PlaceholderCell height={20} />
          <PlaceholderCell height={20} />
          <PlaceholderCell height={20} />
          <PlaceholderCell height={20} />
        </div>
      </div>
    )
  }

  if (isError) {
    return (
      <div className={className}>
        <div className="mb-4 text-title-lg">История перевозки</div>
        <div className="flex flex-col">Информация в настоящий момент недоступна.</div>
      </div>
    )
  }

  if (!tracking.length) {
    return null
  }

  return (
    <div className={className}>
      <div className="mb-4 text-title-lg">История перевозки</div>
      <ul className="list-none">
        {getFilteredAndRenamedOrderTracking(tracking).map(({ statusId, statusName, dateTime }, index) => (
          <li key={statusId} className="relative flex items-center justify-between pb-1 pl-[34px] text-body-md">
            <div
              className={cn(
                'absolute bottom-0 left-[7px] top-0 block w-0.5 bg-outline',
                index === tracking.length - 1 ? 'h-1/2' : 'h-full'
              )}
            />
            {index !== tracking.length - 1 && <div className="absolute left-[7px] top-0 h-full w-0.5 bg-primary" />}
            {index === tracking.length - 1 && (
              <div className="absolute left-[7px] top-0 h-1/2 w-0.5 bg-primary">
                <div className="absolute -left-[2px] top-[6px] h-[6px] w-[6px] rounded-full bg-primary before:absolute before:-left-1/2 before:-top-1/2 before:-ml-[3px] before:-mt-[3px] before:h-[18px] before:w-[18px] before:rounded-full before:bg-state-primary-focused" />
              </div>
            )}
            {statusName}
            <div className="min-w-[100px] text-right text-on-surface-variant">{formatDateToMoscow(dateTime, true)}</div>
          </li>
        ))}
      </ul>
    </div>
  )
}

export default memo(OrderYarcheTracking)
